var _excluded = ["style"],
  _excluded2 = ["spacing"],
  _excluded3 = ["encoding"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { FACET_CHANNELS, getPositionScaleChannel, isChannel, isScaleChannel } from '../channel';
import { getFieldDef, vgField as _vgField } from '../channeldef';
import { DataSourceType } from '../data';
import { forEach, reduce } from '../encoding';
import { replaceExprRef } from '../expr';
import * as log from '../log';
import { hasDiscreteDomain } from '../scale';
import { isFacetSpec } from '../spec';
import { extractCompositionLayout } from '../spec/base';
import { extractTitleConfig, isText } from '../title';
import { normalizeTransform } from '../transform';
import { contains, duplicate, isEmpty, keys, varName } from '../util';
import { isVgRangeStep } from '../vega.schema';
import { assembleAxes as _assembleAxes } from './axis/assemble';
import { signalOrValueRef } from './common';
import { assembleHeaderGroups, assembleLayoutTitleBand, assembleTitleGroup } from './header/assemble';
import { HEADER_CHANNELS } from './header/component';
import { sizeExpr } from './layoutsize/assemble';
import { getSizeTypeFromLayoutSizeType } from './layoutsize/component';
import { assembleLegends as _assembleLegends } from './legend/assemble';
import { parseLegend } from './legend/parse';
import { assembleProjections as _assembleProjections } from './projection/assemble';
import { parseProjection as _parseProjection } from './projection/parse';
import { assembleScales } from './scale/assemble';
import { assembleDomain, getFieldFromDomain } from './scale/domain';
import { parseScales } from './scale/parse';
import { Split } from './split';
export var NameMap = /*#__PURE__*/function () {
  function NameMap() {
    _classCallCheck(this, NameMap);
    this.nameMap = {};
  }
  return _createClass(NameMap, [{
    key: "rename",
    value: function rename(oldName, newName) {
      this.nameMap[oldName] = newName;
    }
  }, {
    key: "has",
    value: function has(name) {
      return this.nameMap[name] !== undefined;
    }
  }, {
    key: "get",
    value: function get(name) {
      // If the name appears in the _nameMap, we need to read its new name.
      // We have to loop over the dict just in case the new name also gets renamed.
      while (this.nameMap[name] && name !== this.nameMap[name]) {
        name = this.nameMap[name];
      }
      return name;
    }
  }]);
}();
/*
  We use type guards instead of `instanceof` as `instanceof` makes
  different parts of the compiler depend on the actual implementation of
  the model classes, which in turn depend on different parts of the compiler.
  Thus, `instanceof` leads to circular dependency problems.

  On the other hand, type guards only make different parts of the compiler
  depend on the type of the model classes, but not the actual implementation.
*/
export function isUnitModel(model) {
  return (model === null || model === void 0 ? void 0 : model.type) === 'unit';
}
export function isFacetModel(model) {
  return (model === null || model === void 0 ? void 0 : model.type) === 'facet';
}
export function isConcatModel(model) {
  return (model === null || model === void 0 ? void 0 : model.type) === 'concat';
}
export function isLayerModel(model) {
  return (model === null || model === void 0 ? void 0 : model.type) === 'layer';
}
export var Model = /*#__PURE__*/function () {
  function Model(spec, type, parent, parentGivenName, config, resolve, view) {
    var _spec$name, _spec$transform;
    _classCallCheck(this, Model);
    this.type = type;
    this.parent = parent;
    this.config = config;
    this.parent = parent;
    this.config = config;
    this.view = replaceExprRef(view);
    // If name is not provided, always use parent's givenName to avoid name conflicts.
    this.name = (_spec$name = spec.name) !== null && _spec$name !== void 0 ? _spec$name : parentGivenName;
    this.title = isText(spec.title) ? {
      text: spec.title
    } : spec.title ? replaceExprRef(spec.title) : undefined;
    // Shared name maps
    this.scaleNameMap = parent ? parent.scaleNameMap : new NameMap();
    this.projectionNameMap = parent ? parent.projectionNameMap : new NameMap();
    this.signalNameMap = parent ? parent.signalNameMap : new NameMap();
    this.data = spec.data;
    this.description = spec.description;
    this.transforms = normalizeTransform((_spec$transform = spec.transform) !== null && _spec$transform !== void 0 ? _spec$transform : []);
    this.layout = type === 'layer' || type === 'unit' ? {} : extractCompositionLayout(spec, type, config);
    this.component = {
      data: {
        sources: parent ? parent.component.data.sources : [],
        outputNodes: parent ? parent.component.data.outputNodes : {},
        outputNodeRefCounts: parent ? parent.component.data.outputNodeRefCounts : {},
        // data is faceted if the spec is a facet spec or the parent has faceted data and data is undefined
        isFaceted: isFacetSpec(spec) || (parent === null || parent === void 0 ? void 0 : parent.component.data.isFaceted) && spec.data === undefined
      },
      layoutSize: new Split(),
      layoutHeaders: {
        row: {},
        column: {},
        facet: {}
      },
      mark: null,
      resolve: _objectSpread({
        scale: {},
        axis: {},
        legend: {}
      }, resolve ? duplicate(resolve) : {}),
      selection: null,
      scales: null,
      projection: null,
      axes: {},
      legends: {}
    };
  }
  return _createClass(Model, [{
    key: "width",
    get: function get() {
      return this.getSizeSignalRef('width');
    }
  }, {
    key: "height",
    get: function get() {
      return this.getSizeSignalRef('height');
    }
  }, {
    key: "parse",
    value: function parse() {
      this.parseScale();
      this.parseLayoutSize(); // depends on scale
      this.renameTopLevelLayoutSizeSignal();
      this.parseSelections();
      this.parseProjection();
      this.parseData(); // (pathorder) depends on markDef; selection filters depend on parsed selections; depends on projection because some transforms require the finalized projection name.
      this.parseAxesAndHeaders(); // depends on scale and layout size
      this.parseLegends(); // depends on scale, markDef
      this.parseMarkGroup(); // depends on data name, scale, layout size, axisGroup, and children's scale, axis, legend and mark.
    }
  }, {
    key: "parseScale",
    value: function parseScale() {
      parseScales(this);
    }
  }, {
    key: "parseProjection",
    value: function parseProjection() {
      _parseProjection(this);
    }
    /**
     * Rename top-level spec's size to be just width / height, ignoring model name.
     * This essentially merges the top-level spec's width/height signals with the width/height signals
     * to help us reduce redundant signals declaration.
     */
  }, {
    key: "renameTopLevelLayoutSizeSignal",
    value: function renameTopLevelLayoutSizeSignal() {
      if (this.getName('width') !== 'width') {
        this.renameSignal(this.getName('width'), 'width');
      }
      if (this.getName('height') !== 'height') {
        this.renameSignal(this.getName('height'), 'height');
      }
    }
  }, {
    key: "parseLegends",
    value: function parseLegends() {
      parseLegend(this);
    }
  }, {
    key: "assembleEncodeFromView",
    value: function assembleEncodeFromView(view) {
      // Exclude "style"
      var _ = view.style,
        baseView = _objectWithoutProperties(view, _excluded);
      var e = {};
      var _iterator = _createForOfIteratorHelper(keys(baseView)),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          var value = baseView[property];
          if (value !== undefined) {
            e[property] = signalOrValueRef(value);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return e;
    }
  }, {
    key: "assembleGroupEncodeEntry",
    value: function assembleGroupEncodeEntry(isTopLevel) {
      var encodeEntry = {};
      if (this.view) {
        encodeEntry = this.assembleEncodeFromView(this.view);
      }
      if (!isTopLevel) {
        // Descriptions are already added to the top-level description so we only need to add them to the inner views.
        if (this.description) {
          encodeEntry['description'] = signalOrValueRef(this.description);
        }
        // For top-level spec, we can set the global width and height signal to adjust the group size.
        // For other child specs, we have to manually set width and height in the encode entry.
        if (this.type === 'unit' || this.type === 'layer') {
          return _objectSpread({
            width: this.getSizeSignalRef('width'),
            height: this.getSizeSignalRef('height')
          }, encodeEntry);
        }
      }
      return isEmpty(encodeEntry) ? undefined : encodeEntry;
    }
  }, {
    key: "assembleLayout",
    value: function assembleLayout() {
      if (!this.layout) {
        return undefined;
      }
      var _this$layout = this.layout,
        spacing = _this$layout.spacing,
        layout = _objectWithoutProperties(_this$layout, _excluded2);
      var component = this.component,
        config = this.config;
      var titleBand = assembleLayoutTitleBand(component.layoutHeaders, config);
      return _objectSpread(_objectSpread(_objectSpread({
        padding: spacing
      }, this.assembleDefaultLayout()), layout), titleBand ? {
        titleBand: titleBand
      } : {});
    }
  }, {
    key: "assembleDefaultLayout",
    value: function assembleDefaultLayout() {
      return {};
    }
  }, {
    key: "assembleHeaderMarks",
    value: function assembleHeaderMarks() {
      var layoutHeaders = this.component.layoutHeaders;
      var headerMarks = [];
      var _iterator2 = _createForOfIteratorHelper(FACET_CHANNELS),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var channel = _step2.value;
          if (layoutHeaders[channel].title) {
            headerMarks.push(assembleTitleGroup(this, channel));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      var _iterator3 = _createForOfIteratorHelper(HEADER_CHANNELS),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _channel = _step3.value;
          headerMarks = headerMarks.concat(assembleHeaderGroups(this, _channel));
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return headerMarks;
    }
  }, {
    key: "assembleAxes",
    value: function assembleAxes() {
      return _assembleAxes(this.component.axes, this.config);
    }
  }, {
    key: "assembleLegends",
    value: function assembleLegends() {
      return _assembleLegends(this);
    }
  }, {
    key: "assembleProjections",
    value: function assembleProjections() {
      return _assembleProjections(this);
    }
  }, {
    key: "assembleTitle",
    value: function assembleTitle() {
      var _this$title;
      var _ref = (_this$title = this.title) !== null && _this$title !== void 0 ? _this$title : {},
        encoding = _ref.encoding,
        titleNoEncoding = _objectWithoutProperties(_ref, _excluded3);
      var title = _objectSpread(_objectSpread(_objectSpread({}, extractTitleConfig(this.config.title).nonMarkTitleProperties), titleNoEncoding), encoding ? {
        encode: {
          update: encoding
        }
      } : {});
      if (title.text) {
        if (contains(['unit', 'layer'], this.type)) {
          // Unit/Layer
          if (contains(['middle', undefined], title.anchor)) {
            var _title$frame;
            (_title$frame = title.frame) !== null && _title$frame !== void 0 ? _title$frame : title.frame = 'group';
          }
        } else {
          var _title$anchor;
          // composition with Vega layout
          // Set title = "start" by default for composition as "middle" does not look nice
          // https://github.com/vega/vega/issues/960#issuecomment-471360328
          (_title$anchor = title.anchor) !== null && _title$anchor !== void 0 ? _title$anchor : title.anchor = 'start';
        }
        return isEmpty(title) ? undefined : title;
      }
      return undefined;
    }
    /**
     * Assemble the mark group for this model. We accept optional `signals` so that we can include concat top-level signals with the top-level model's local signals.
     */
  }, {
    key: "assembleGroup",
    value: function assembleGroup() {
      var signals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var group = {};
      signals = signals.concat(this.assembleSignals());
      if (signals.length > 0) {
        group.signals = signals;
      }
      var layout = this.assembleLayout();
      if (layout) {
        group.layout = layout;
      }
      group.marks = [].concat(this.assembleHeaderMarks(), this.assembleMarks());
      // Only include scales if this spec is top-level or if parent is facet.
      // (Otherwise, it will be merged with upper-level's scope.)
      var scales = !this.parent || isFacetModel(this.parent) ? assembleScales(this) : [];
      if (scales.length > 0) {
        group.scales = scales;
      }
      var axes = this.assembleAxes();
      if (axes.length > 0) {
        group.axes = axes;
      }
      var legends = this.assembleLegends();
      if (legends.length > 0) {
        group.legends = legends;
      }
      return group;
    }
  }, {
    key: "getName",
    value: function getName(text) {
      return varName((this.name ? "".concat(this.name, "_") : '') + text);
    }
  }, {
    key: "getDataName",
    value: function getDataName(type) {
      return this.getName(DataSourceType[type].toLowerCase());
    }
    /**
     * Request a data source name for the given data source type and mark that data source as required.
     * This method should be called in parse, so that all used data source can be correctly instantiated in assembleData().
     * You can lookup the correct dataset name in assemble with `lookupDataSource`.
     */
  }, {
    key: "requestDataName",
    value: function requestDataName(name) {
      var fullName = this.getDataName(name);
      // Increase ref count. This is critical because otherwise we won't create a data source.
      // We also increase the ref counts on OutputNode.getSource() calls.
      var refCounts = this.component.data.outputNodeRefCounts;
      refCounts[fullName] = (refCounts[fullName] || 0) + 1;
      return fullName;
    }
  }, {
    key: "getSizeSignalRef",
    value: function getSizeSignalRef(layoutSizeType) {
      if (isFacetModel(this.parent)) {
        var sizeType = getSizeTypeFromLayoutSizeType(layoutSizeType);
        var channel = getPositionScaleChannel(sizeType);
        var scaleComponent = this.component.scales[channel];
        if (scaleComponent && !scaleComponent.merged) {
          // independent scale
          var type = scaleComponent.get('type');
          var range = scaleComponent.get('range');
          if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
            var scaleName = scaleComponent.get('name');
            var domain = assembleDomain(this, channel);
            var field = getFieldFromDomain(domain);
            if (field) {
              var fieldRef = _vgField({
                aggregate: 'distinct',
                field: field
              }, {
                expr: 'datum'
              });
              return {
                signal: sizeExpr(scaleName, scaleComponent, fieldRef)
              };
            } else {
              log.warn(log.message.unknownField(channel));
              return null;
            }
          }
        }
      }
      return {
        signal: this.signalNameMap.get(this.getName(layoutSizeType))
      };
    }
    /**
     * Lookup the name of the datasource for an output node. You probably want to call this in assemble.
     */
  }, {
    key: "lookupDataSource",
    value: function lookupDataSource(name) {
      var node = this.component.data.outputNodes[name];
      if (!node) {
        // Name not found in map so let's just return what we got.
        // This can happen if we already have the correct name.
        return name;
      }
      return node.getSource();
    }
  }, {
    key: "getSignalName",
    value: function getSignalName(oldSignalName) {
      return this.signalNameMap.get(oldSignalName);
    }
  }, {
    key: "renameSignal",
    value: function renameSignal(oldName, newName) {
      this.signalNameMap.rename(oldName, newName);
    }
  }, {
    key: "renameScale",
    value: function renameScale(oldName, newName) {
      this.scaleNameMap.rename(oldName, newName);
    }
  }, {
    key: "renameProjection",
    value: function renameProjection(oldName, newName) {
      this.projectionNameMap.rename(oldName, newName);
    }
    /**
     * @return scale name for a given channel after the scale has been parsed and named.
     */
  }, {
    key: "scaleName",
    value: function scaleName(originalScaleName, parse) {
      if (parse) {
        // During the parse phase always return a value
        // No need to refer to rename map because a scale can't be renamed
        // before it has the original name.
        return this.getName(originalScaleName);
      }
      // If there is a scale for the channel, it should either
      // be in the scale component or exist in the name map
      if (
      // If there is a scale for the channel, there should be a local scale component for it
      isChannel(originalScaleName) && isScaleChannel(originalScaleName) && this.component.scales[originalScaleName] ||
      // in the scale name map (the scale get merged by its parent)
      this.scaleNameMap.has(this.getName(originalScaleName))) {
        return this.scaleNameMap.get(this.getName(originalScaleName));
      }
      return undefined;
    }
    /**
     * @return projection name after the projection has been parsed and named.
     */
  }, {
    key: "projectionName",
    value: function projectionName(parse) {
      if (parse) {
        // During the parse phase always return a value
        // No need to refer to rename map because a projection can't be renamed
        // before it has the original name.
        return this.getName('projection');
      }
      if (this.component.projection && !this.component.projection.merged || this.projectionNameMap.has(this.getName('projection'))) {
        return this.projectionNameMap.get(this.getName('projection'));
      }
      return undefined;
    }
    /**
     * Traverse a model's hierarchy to get the scale component for a particular channel.
     */
  }, {
    key: "getScaleComponent",
    value: function getScaleComponent(channel) {
      /* istanbul ignore next: This is warning for debugging test */
      if (!this.component.scales) {
        throw new Error('getScaleComponent cannot be called before parseScale(). Make sure you have called parseScale or use parseUnitModelWithScale().');
      }
      var localScaleComponent = this.component.scales[channel];
      if (localScaleComponent && !localScaleComponent.merged) {
        return localScaleComponent;
      }
      return this.parent ? this.parent.getScaleComponent(channel) : undefined;
    }
  }, {
    key: "getScaleType",
    value: function getScaleType(channel) {
      var scaleComponent = this.getScaleComponent(channel);
      return scaleComponent ? scaleComponent.get('type') : undefined;
    }
    /**
     * Traverse a model's hierarchy to get a particular selection component.
     */
  }, {
    key: "getSelectionComponent",
    value: function getSelectionComponent(variableName, origName) {
      var sel = this.component.selection[variableName];
      if (!sel && this.parent) {
        sel = this.parent.getSelectionComponent(variableName, origName);
      }
      if (!sel) {
        throw new Error(log.message.selectionNotFound(origName));
      }
      return sel;
    }
    /**
     * Returns true if the model has a signalRef for an axis orient.
     */
  }, {
    key: "hasAxisOrientSignalRef",
    value: function hasAxisOrientSignalRef() {
      var _this$component$axes$, _this$component$axes$2;
      return ((_this$component$axes$ = this.component.axes.x) === null || _this$component$axes$ === void 0 ? void 0 : _this$component$axes$.some(function (a) {
        return a.hasOrientSignalRef();
      })) || ((_this$component$axes$2 = this.component.axes.y) === null || _this$component$axes$2 === void 0 ? void 0 : _this$component$axes$2.some(function (a) {
        return a.hasOrientSignalRef();
      }));
    }
  }]);
}();
/** Abstract class for UnitModel and FacetModel. Both of which can contain fieldDefs as a part of its own specification. */
export var ModelWithField = /*#__PURE__*/function (_Model) {
  function ModelWithField() {
    _classCallCheck(this, ModelWithField);
    return _callSuper(this, ModelWithField, arguments);
  }
  _inherits(ModelWithField, _Model);
  return _createClass(ModelWithField, [{
    key: "vgField",
    value: /** Get "field" reference for Vega */
    function vgField(channel) {
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fieldDef = this.fieldDef(channel);
      if (!fieldDef) {
        return undefined;
      }
      return _vgField(fieldDef, opt);
    }
  }, {
    key: "reduceFieldDef",
    value: function reduceFieldDef(f, init) {
      return reduce(this.getMapping(), function (acc, cd, c) {
        var fieldDef = getFieldDef(cd);
        if (fieldDef) {
          return f(acc, fieldDef, c);
        }
        return acc;
      }, init);
    }
  }, {
    key: "forEachFieldDef",
    value: function forEachFieldDef(f, t) {
      forEach(this.getMapping(), function (cd, c) {
        var fieldDef = getFieldDef(cd);
        if (fieldDef) {
          f(fieldDef, c);
        }
      }, t);
    }
  }]);
}(Model);